import PropTypes from 'prop-types';
import React from 'react';

import './style.scss';
import ReforalLogo from '@assets/img/reforal-logo.svg';
import LocaleService from '@services/LocaleService';

function LoadingBlock({ enabled, withReforalLogo }) {
  const i18nGeneral = LocaleService.getTranslations('general');
  if (enabled) {
    return (
      <div className="loading-backdrop">
        <div className="d-flex align-items-center justify-content-center flex-column gap-4">
          {
            withReforalLogo && (
              <div
                className="d-flex align-items-center justify-content-center"
              >
                <span>
                  <img src={ReforalLogo} height={45} alt="Reforal Logo" />
                </span>
                <span className="title">
                  {i18nGeneral.header.title}
                </span>
              </div>
            )
          }
          <div className="spinner-border text-primary" role="status" />
        </div>
      </div>
    );
  }

  return null;
}

LoadingBlock.defaultProps = {
  enabled: false,
  withReforalLogo: false,
};

LoadingBlock.propTypes = {
  enabled: PropTypes.bool,
  withReforalLogo: PropTypes.bool,
};

export default LoadingBlock;
